<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      :id="`input-billing_address_city`"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import BaseSignupTextInput from "../core/AbstractSignupTextInput";
import AbstractSignupTextInput from "../core/AbstractSignupTextInput";
import BaseInputMixin from "@/mixins/signupInputMixin";
import InputWidget from "@/components/core/InputWidget.vue";

export default {
  name: "BillingCity",
  components: {InputWidget, AbstractSignupTextInput, BaseSignupTextInput},
  mixins: [BaseInputMixin('billing_address.city')],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: 'billing_address.city',
      defaultLabel: this.$t("City")
    }
  }
}
</script>

<style scoped>

</style>
